import { HTMLTable } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';
import Empty from '../../../components/Empty';
import Error from '../../../components/Error';
import NoResults from '../../../components/NoResults';
import TableHeaderCell from '../../../components/TableHeaderCell';
import { useAllotmentListQuery } from '../../../generated/graphql';
import useQueryParams from '../../../hooks/useQueryParams';
import { dummyAllotments } from '../dummy';
import AllotmentListItem from './AllotmentListItem';

const LoadingTable = () => (
  <HTMLTable condensed className="w-full">
    <thead>
      <tr>
        <TableHeaderCell>Status</TableHeaderCell>
        <TableHeaderCell>Name</TableHeaderCell>
        <TableHeaderCell>Karten</TableHeaderCell>
        <TableHeaderCell>Gültigkeit</TableHeaderCell>
      </tr>
    </thead>
    <tbody>
      {dummyAllotments.map((item, index) => (
        <AllotmentListItem key={index} item={item} skeleton />
      ))}
    </tbody>
  </HTMLTable>
);

const AllotmentList = () => {
  const queryParams = useQueryParams();
  const navigate = useNavigate();
  const filters = queryParams.get('filters');

  const { data, loading, error } = useAllotmentListQuery({
    // It is just too complicated to update cached queries after
    // mutations have succeeded
    fetchPolicy: 'network-only',
  });

  if (loading) return <LoadingTable />;
  if (error) return <Error />;
  if (!data?.allotments) return filters ? <NoResults /> : <Empty />;

  return (
    <HTMLTable interactive condensed className="w-full">
      <thead>
        <tr>
          <TableHeaderCell>Status</TableHeaderCell>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Karten</TableHeaderCell>
          <TableHeaderCell>Gültigkeit</TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {data.allotments.map((allotment) => (
          <AllotmentListItem
            key={allotment.id}
            item={allotment}
            onClick={() => navigate(`/allotments/${allotment.id}`)}
          />
        ))}
      </tbody>
    </HTMLTable>
  );
};

export default AllotmentList;
